import { getNavbarSubThemeOptions, NAVBAR_THEME_IDS, NavbarThemeWrapperProps } from './constants';
import { Navbar } from '../navbar/Navbar';
import { ButtonType } from '../_misc/buttons/ButtonType';
import { ReactNode, memo } from 'react';
import { ThemePrimary } from '../../context/theme/ThemeConstantsUpdated';
import { LightMode } from '../../constants';

const { primaryBackground } = ThemePrimary;

// export const getThemeButtonType = (themeId: string): ButtonType => {
//     switch (themeId) {
//         case NAVBAR_THEME_IDS.vibrant:
//             return ButtonType.Link;
//         case NAVBAR_THEME_IDS.minimalist:
//         case NAVBAR_THEME_IDS.basic:
//         case NAVBAR_THEME_IDS.default:
//         default:
//             return ButtonType.Primary;
//     }
// };

const NavbarThemeWrapperComponent = (props: NavbarThemeWrapperProps) => {
  const { themeRevision, pageThemeRevision } = props;
  const isLightingLocked =
    props.isLightingLocked || (pageThemeRevision != null && pageThemeRevision.lightMode !== LightMode.any);
  const subThemeOptions = getNavbarSubThemeOptions(themeRevision?.themeId);
  const currentSubTheme = subThemeOptions?.find((o) => o.value === themeRevision?.subTheme);
  const isVibrant = currentSubTheme?.value === 'primary';
  let Nav: ReactNode;

  switch (themeRevision?.themeId) {
    // case NAVBAR_THEME_IDS.vibrantUltra:
    // case NAVBAR_THEME_IDS.vibrantLite:
    //     Nav = (
    //         <Navbar
    //             {...props}
    //             buttonType={ButtonType.Secondary}
    //             isVibrant
    //             isLightingLocked={isLightingLocked}
    //             backgroundClassOverride={primaryBackground}
    //             removeBorder
    //         />
    //     );
    //     break;
    case NAVBAR_THEME_IDS.basicUltra:
    case NAVBAR_THEME_IDS.basicPro:
    case NAVBAR_THEME_IDS.default:
    default:
      Nav = (
        <Navbar
          {...props}
          isLightingLocked={isLightingLocked}
          buttonType={isVibrant ? ButtonType.Secondary : ButtonType.Primary}
          isVibrant={isVibrant}
          backgroundClassOverride={isVibrant ? primaryBackground : undefined}
          removeBorder={isVibrant}
        />
      );
      break;
  }

  return <div className="z-[53]">{Nav}</div>;
};

export const NavbarThemeWrapper = memo(NavbarThemeWrapperComponent);

// export const CartToggleThemeWrapper = (props: NavbarButtonProps) => {
//     const { revision } = props;

//     switch (revision?.subTheme) {
//         case NAVBAR_THEME_IDS.vibrantUltra:
//         case NAVBAR_THEME_IDS.vibrantLite:
//             return <CartToggle buttonType={ButtonType.Secondary} />;
//         case NAVBAR_THEME_IDS.basicUltra:
//         case NAVBAR_THEME_IDS.basicPro:
//         case NAVBAR_THEME_IDS.default:
//         default:
//             return <CartToggle buttonType={ButtonType.Primary} />;
//     }
// };
